import { render } from "./CompanyCreationView.vue?vue&type=template&id=fd0ab4ce"
import script from "./CompanyCreationView.vue?vue&type=script&lang=js"
export * from "./CompanyCreationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__